import { Component } from '@angular/core';

@Component({
  selector: 'app-avia-card-skeleton',
  standalone: true,
  templateUrl: './avia-card-skeleton.component.html',
  styleUrl: './avia-card-skeleton.component.scss',
})
export class SkeletonCardComponent {}
